import { Controller } from "@hotwired/stimulus"

// Submit stays enabled in HTML so no-JS users can submit when native validation passes
// (`required` checkboxes). After connect we mirror that rule by disabling until checked.
export default class extends Controller {
  static targets = ["checkbox", "submit"]

  connect() {
    this.toggle()
  }

  toggle() {
    const enabled =
      this.checkboxTargets.length > 0 &&
      this.checkboxTargets.every((el) => el.checked)
    this.submitTargets.forEach((el) => {
      el.disabled = !enabled
    })
  }
}
